import * as React from "react"
const Gaining2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#BDDEFF"
      d="M7.206 13.835a6.63 6.63 0 1 1 13.258 0 6.63 6.63 0 0 1-13.258 0Z"
    />
    <path
      fill="#BDDEFF"
      d="M13.835 3.695c-5.6 0-10.14 4.54-10.14 10.14 0 5.6 4.54 10.14 10.14 10.14 5.6 0 10.14-4.54 10.14-10.14 0-.343-.017-.682-.05-1.015a1.127 1.127 0 1 1 2.242-.223c.04.408.062.82.062 1.238 0 6.845-5.55 12.394-12.394 12.394-6.845 0-12.394-5.55-12.394-12.394C1.44 6.99 6.99 1.441 13.835 1.441c2.848 0 5.474.962 7.567 2.578a3.38 3.38 0 1 1-1.61 1.61 10.09 10.09 0 0 0-5.957-1.934Z"
    />
  </svg>
)
export default Gaining2
